import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withWrapper } from "create-react-server/wrapper";
import { bindActionCreators } from "redux";
import controls from "modules/controls";
import "./ControlsContainer.css";

import ControlsButton from "components/ControlsButton";
import ControlsItem from "components/ControlsItem";

class ControlsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      array: [],
      prevWidth: null
    };

    this.switchControlsView = this.switchControlsView.bind(this);
  }

  componentDidMount() {
    this.props.getControls();

    this.setState({
      prevWidth: window.innerWidth
    });
  }

  componentWillReceiveProps(nextProps) {
    this.filteresArray(nextProps.controls);
  }

  filteresArray(controls) {
    let filteredArray = Object.keys(controls).map(obj => ({
      ...controls[obj],
      ["classObject"]: "controls_hide"
    }));

    filteredArray = filteredArray.filter(item => {
      return item.controls.length > 1 && item.title;
    });

    this.setState({
      array: filteredArray
    });
  }

  switchControlsView(number) {
    const { array, prevWidth } = this.state;

    let lineNumber;
    let colsNumber;
    let newArray;
    let windowWidth = window.innerWidth;

    const col_0 = 0;
    const col_1 = 1;
    const col_2 = 2;
    const col_3 = 3;
    const col_4 = 4;

    const line_4 = [{ col_0, col_1, col_2, col_3 }, { col_4 }];
    const line_3 = [{ col_0, col_1, col_2 }, { col_3, col_4 }];
    const line_2 = [{ col_0, col_1 }, { col_2, col_3 }, { col_4 }];
    const line_1 = [{ col_0 }, { col_1 }, { col_2 }, { col_3 }, { col_4 }];

    if (windowWidth > 1150) lineNumber = line_4;
    if (windowWidth <= 1150 && windowWidth !== 930) lineNumber = line_3;
    if (windowWidth <= 930 && windowWidth !== 610) lineNumber = line_2;
    if (windowWidth < 610) lineNumber = line_1;

    switch (lineNumber) {
      case line_1:
        colsNumber = number;

        break;
      case line_2:
        colsNumber = number <= 1 ? 0 : number === 2 || number === 3 ? 1 : 2;

        break;
      case line_3:
        colsNumber = number <= 2 ? 0 : 1;

        break;
      case line_4:
        colsNumber = number <= 3 ? 0 : 1;

        break;
      default:
        break;
    }

    if (windowWidth !== prevWidth) {
      newArray = array.map(item => {
        return Object.defineProperty(item, "classObject", {
          value: "controls_hide"
        });
      });
    }

    for (let col in lineNumber[colsNumber]) {
      newArray = array.map((item, i) => {
        let prop = Object.getOwnPropertyDescriptor(item, "classObject").value;

        if (lineNumber[colsNumber][col] === i) {
          if (prop === "controls_hide") {
            return Object.defineProperty(item, "classObject", {
              value: "controls_show"
            });
          }

          if (prop === "controls_show") {
            return Object.defineProperty(item, "classObject", {
              value: "controls_hide"
            });
          }
        } else {
          return item;
        }
      });
    }

    this.setState(state => ({
      array: newArray,
      prevWidth: state.prevWidth !== windowWidth ? windowWidth : state.prevWidth
    }));
  }

  render() {
    const { array } = this.state;
    const { controls } = this.props;

    return (
      <div>
        {Object.keys(controls).length ? (
          <div>
            <div className="group-controls in-line">
              <div className="group-controls controls-types">
                {controls.works_on_holidays &&
                  controls.works_on_holidays.controls.map((btn, i) => (
                    <ControlsButton key={i} btn={btn} />
                  ))}
                {controls.schedule &&
                  controls.schedule.controls.map((btn, i) => (
                    <ControlsButton key={i} btn={btn} />
                  ))}
                {controls.disabledAccess &&
                  controls.disabledAccess.controls.map((btn, i) => (
                    <ControlsButton key={i} btn={btn} />
                  ))}
                {controls.single_library_card &&
                  controls.single_library_card.controls.map((btn, i) => (
                    <ControlsButton
                      key={i}
                      btn={btn}
                      style={{
                        background: "#f9eed2"
                      }}
                    />
                  ))}
              </div>
              <div className="group-controls controls-types">
                {controls.libraryType &&
                  controls.libraryType.controls.map((btn, i) => (
                    <ControlsButton key={i} btn={btn} />
                  ))}
              </div>
            </div>
            <div className="group-controls group-controls--border">
              {array.map((items, i) => {
                return (
                  <ControlsItem
                    key={i}
                    number={i}
                    item={items}
                    switchControlsView={this.switchControlsView}
                  />
                );
              })}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  controls: state.controls.controls
});

const mapDispatchToProps = dispatch => ({
  getControls: bindActionCreators(controls.actions.getControls, dispatch)
});

export default withWrapper(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ControlsContainer)
  )
);



// WEBPACK FOOTER //
// ./src/components/ControlsContainer/ControlsContainer.js